import { getTrainSchedule } from "../../../app/api/getTrainSchedule";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { ITrainScheduleActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/TrainScheduleActionParams";
import { ITrainScheduleResponse } from "../../../Orchestrator/Types/Interface/ITrainScheduleResponse";

export class GetTrainScheduleAction extends BaseAction<
  ITrainScheduleResponse | null,
  ITrainScheduleActionParams
> {
  // Read-only GET — coalesce overlapping calls (e.g. React StrictMode's
  // double-mount) into a single request instead of firing duplicates.
  protected override deduplicate = true;

  override async run(): Promise<ITrainScheduleResponse | null> {
    const { date, from, to, limit, offset, arrivalFromTime } = this.params!;
    let trainScheduleData: ITrainScheduleResponse | null = null;

    try {
      updateRecoilState("trainScheduleDataAtom", null);
      const response = await getTrainSchedule(
        date,
        from,
        to,
        limit,
        offset,
        arrivalFromTime ?? ""
      );

      if (response.status === "ok" && response.answer) {
        trainScheduleData = response.answer as ITrainScheduleResponse;
        updateRecoilState("trainScheduleDataAtom", trainScheduleData);
      } else {
        console.warn("Unexpected train schedule API response:", response);
      }
    } catch (error) {
      console.error("Error fetching train schedule:", error);
    }

    return trainScheduleData;
  }
}

export const getTrainScheduleAction = new GetTrainScheduleAction();